export default class LoginModal {
  constructor(component) {
    this.dom = {
      $component: component,
      $body: document.querySelector('body'),
      $loginModalToggles: document.querySelectorAll('.js-loginModalToggle'),
      $loginModal: document.querySelector('.js-loginModal'),
      $loginModalUnderlay: document.querySelector('.js-loginModalUnderlay'),
    }
    this.state = {
      loginModalOpen: false,
      loginModalOpenClass: 'openLoginModal',
      loginModalUnderlayActiveClass: 'isActive',
      bodyFixedClass: 'bodyFixed',
    }
    this.mount()
    this.bindToWindow()
  }

  mount() {
    this.loginModalHandler()
    document.addEventListener('loginModalToggle', this.modalCheck.bind(this))
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.LoginModal = this
  }

  loginModalHandler() {
    const { dom } = this
    if (dom.$loginModalToggles) {
      dom.$loginModalToggles.forEach(($toggle) => $toggle.addEventListener('click', this.modalCheck.bind(this)))
    }
  }

  modalCheck() {
    const { dom, state } = this

    if (state.loginModalOpen) {
      dom.$loginModal.setAttribute('aria-hidden', 'true')
      dom.$loginModal.setAttribute('aria-expanded', 'false')
      dom.$loginModal.classList.remove(state.loginModalOpenClass)
      dom.$loginModalUnderlay.classList.remove(state.loginModalUnderlayActiveClass)
      dom.$body.classList.remove(state.bodyFixedClass)
      state.loginModalOpen = false
    } else {
      dom.$loginModal.setAttribute('aria-hidden', 'false')
      dom.$loginModal.setAttribute('aria-expanded', 'true')
      dom.$loginModal.classList.add(state.loginModalOpenClass)
      dom.$loginModalUnderlay.classList.add(state.loginModalUnderlayActiveClass)
      if (window.innerWidth <= 1024) {
        dom.$body.classList.add(state.bodyFixedClass)
      }
      state.loginModalOpen = true
    }
  }
}
